import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { CommonmodalPage } from '../commonmodal/commonmodal';

/**
 * Generated class for the EmailauthPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-emailauth',
  templateUrl: 'emailauth.html',
})
export class EmailauthPage {
	@ViewChild('oneInput') oneInput;
	@ViewChild('twoInput') twoInput;
	@ViewChild('threeInput') threeInput;
	@ViewChild('fourInput') fourInput;
	@ViewChild('fiveInput') fiveInput;
	@ViewChild('sixInput') sixInput;

	timeInSeconds;
	time;
	runTimer;
	hasStarted;
	hasFinished;
	remainingTime;
	displayTime;

	one;
	two;
	three;
	four;
	five;
	six;

	id: string;
	name: string;
	password: string;
	email: string;
	country: string;
	phone: string;
	center: string;
	birthday: string;
	chucheon: string;

	texts: any = [];
    language: string;

    public isEnabledBtn: boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		private http: HttpService,
		public app: App
	) {
		this.id = this.navParams.get('id');
		this.name = this.navParams.get('name');
		this.password = this.navParams.get('password');
		this.email = this.navParams.get('email');
		this.country = this.navParams.get('country');
		this.phone = this.navParams.get('phone');
		this.center = this.navParams.get('center');
		this.chucheon = this.navParams.get('chucheon');
		this.birthday = this.navParams.get('birthday');
		// this.chucheon = this.navParams.get('chucheon');
	}

	ionViewWillEnter() {
		setTimeout(() => {
			this.oneInput.setFocus();
		},500);
		this._inputChange();

		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).emailauth;
	}

	ngOnInit() {
		this._initTimer();
		this._startTimer();
	}

	// set(item) {
	// 	if (item == 'one') {
	// 		this.one = '';
	// 	} else if (item == 'two') {
	// 		this.two = '';
	// 	} else if (item == 'three') {
	// 		this.three = '';
	// 	} else if (item == 'four') {
	// 		this.four = '';
	// 	} else if (item == 'five') {
	// 		this.five = '';
	// 	} else if (item == 'six') {
	// 		this.six = '';
	// 	}
	// }

	_inputChange() {
		
		if(this.one != '' && this.one != null && this.one != undefined) {
			this.twoInput.setFocus();

			if(this.two != '' && this.two != null && this.two != undefined) {
				this.threeInput.setFocus();

				if(this.three != '' && this.three != null && this.three != undefined) {
					this.fourInput.setFocus();

					if(this.four != '' && this.four != null && this.four != undefined) {
						this.fiveInput.setFocus();

						if(this.five != '' && this.five != null && this.five != undefined) {
							this.sixInput.setFocus();
						}

					} 

				} 

			}

		}
	}

	_send() {
        this.isEnabledBtn = false;
        
		let auth = this.one + this.two + this.three + this.four + this.five + this.six;

		let url = "register/index/authenticate";
		let body = JSON.stringify({ 
			email: this.email,
			key: auth,
            language: this.language,
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this._pauseTimer();
				this.hasFinished = true;

				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: [
						{
							text: 'OK',
							handler: () => {
								let modal = this.modalCtrl.create(CommonmodalPage);
								modal.present();
								modal.onDidDismiss( data => {
                                    this.navCtrl.pop();
									this.navCtrl.setRoot(LoginPage);
								});
							}
						}
					]
				});
				alert.present();
                this.isEnabledBtn = true;
				
			} else if(res.result ==="LOGOUT"){
                this._pauseTimer();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isEnabledBtn = true;
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this._pauseTimer();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isEnabledBtn = true;
			}
		},(err)=>{	
			//// HTTP 에러인 경우
            this._pauseTimer();
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
            this.isEnabledBtn = true;
		});
	}

	_reauth() {
        this.isEnabledBtn = false;

		let url = "register";
		let body = JSON.stringify({ 
			id: this.id,
			name: this.name,
			password: this.password,
			email: this.email,
			country: this.country,
			phone: this.phone,
			birthday: this.birthday,
			center: this.center,
			chucheon: this.chucheon,
            language: this.language
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();

				this._pauseTimer();
				setTimeout(() => {
					this._initTimer();
					this._startTimer();
				}, 1000);
                this.isEnabledBtn = true;

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isEnabledBtn = true;
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isEnabledBtn = true;
			}
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
            this.isEnabledBtn = true;
		});
	}

	_initTimer() {
		// Pomodoro is usually for 25 minutes
		if (!this.timeInSeconds) { 
			this.timeInSeconds = 600;
		}
		
		this.time = this.timeInSeconds;
		this.runTimer = false;
		this.hasStarted = false;
		this.hasFinished = false;
		this.remainingTime = this.timeInSeconds;
		
		this.displayTime = this._getSecondsAsDigitalClock(this.remainingTime);
	}
	
	_startTimer() {
		this.runTimer = true;
		this.hasStarted = true;
		this._timerTick();
	}
	
	_pauseTimer() {
		this.runTimer = false;
	}
	
	_resumeTimer() {
		this._startTimer();
	}
	
	_timerTick() {
		setTimeout(() => {
		
			if (!this.runTimer) { return; }
				this.remainingTime--;
				this.displayTime = this._getSecondsAsDigitalClock(this.remainingTime);
			if (this.remainingTime > 0) {
				this._timerTick();
			}
			else {
				this.hasFinished = true;
				
			}
		}, 1000);
	}
	
	_getSecondsAsDigitalClock(inputSeconds: number) {
		var sec_num = parseInt(inputSeconds.toString(), 10); // don't forget the second param
		var hours = Math.floor(sec_num / 3600);
		var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
		var seconds = sec_num - (hours * 3600) - (minutes * 60);
		// var hoursString = '';
		var minutesString = '';
		var secondsString = '';
		// hoursString = (hours < 10) ? "0" + hours : hours.toString();
		minutesString = (minutes < 10) ? "0" + minutes : minutes.toString();
		secondsString = (seconds < 10) ? "0" + seconds : seconds.toString();
		return minutesString + ':' + secondsString;
	}

	_close() {
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/emailauth/emailauth.ts